import type { StorageAdapter } from './storage-adapter.js';
import type { SaveDataV1 } from './save-schema.js';

export interface AutoSaveOptions {
  intervalSec?: number;
  saveKey?: string;
  onSave?: (data: SaveDataV1) => void;
}

export class AutoSaveController {
  private timer: number = 0;
  private intervalSec: number;
  private saveKey: string;
  private adapter: StorageAdapter;
  private onSave?: (data: SaveDataV1) => void;
  private lastSavedTimestamp: number = 0;

  constructor(adapter: StorageAdapter, options: AutoSaveOptions = {}) {
    this.adapter = adapter;
    this.intervalSec = options.intervalSec ?? 30.0;
    this.saveKey = options.saveKey ?? 'slimebound_save_v1';
    this.onSave = options.onSave;
  }

  public getLastSavedTimestamp(): number {
    return this.lastSavedTimestamp;
  }

  public saveNow(data: SaveDataV1): void {
    const serialized = JSON.stringify(data);
    this.adapter.setItem(this.saveKey, serialized);
    this.lastSavedTimestamp = Date.now();
    this.timer = 0;
    if (this.onSave) {
      this.onSave(data);
    }
  }

  public load(): SaveDataV1 | null {
    const raw = this.adapter.getItem(this.saveKey);
    if (!raw || typeof raw !== 'string') return null;
    try {
      return JSON.parse(raw) as SaveDataV1;
    } catch {
      return null;
    }
  }

  public update(dt: number, stateProvider: () => SaveDataV1): boolean {
    this.timer += dt;
    if (this.timer >= this.intervalSec) {
      const data = stateProvider();
      this.saveNow(data);
      return true;
    }
    return false;
  }
}
